import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "flex px-4 mt-2",
  id: "hh"
}
const _hoisted_2 = { class: "flex flex-row items-center justify-between w-full h-full px-4 text-white" }
const _hoisted_3 = { class: "flex flex-col" }
const _hoisted_4 = { class: "text-xl font-bold text-accent" }
const _hoisted_5 = { class: "flex items-center text-sm" }
const _hoisted_6 = { class: "flex items-center space-x-4" }
const _hoisted_7 = {
  key: 0,
  id: "switchTag",
  class: "flex items-center space-x-2"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "Agence de :", -1)
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = {
  key: 0,
  class: "flex flex-row items-center justify-between"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col w-2/3" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-2xl text-gray-200" }, " Nous sommes ravis de vous accueillir parmi notre communauté grandissante d'entreprises satisfaites. "),
  /*#__PURE__*/_createElementVNode("p", { class: "my-5 text-gray-400" }, [
    /*#__PURE__*/_createTextVNode(" Avant de commencer à profiter de toutes les fonctionnalités offertes par notre logiciel, nous vous invitons à effectuer une étape importante : "),
    /*#__PURE__*/_createElementVNode("strong", null, " Créer la succursale de votre entreprise. "),
    /*#__PURE__*/_createTextVNode(" Cette étape cruciale permettra d'établir une base solide pour la gestion de votre flotte, de vos passagers, de votre personnel, de vos colis, des visites techniques, de l'embarquement, et bien plus encore. ")
  ])
], -1)
const _hoisted_13 = { key: 1 }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", { class: "my-5 text-gray-400" }, [
  /*#__PURE__*/_createTextVNode(" Avant de commencer à profiter de toutes les fonctionnalités offertes par notre logiciel, nous vous invitons à effectuer une étape importante : "),
  /*#__PURE__*/_createElementVNode("strong", null, " Créer la succursale de votre entreprise. "),
  /*#__PURE__*/_createTextVNode(" Cette étape cruciale permettra d'établir une base solide pour la gestion de votre flotte, de vos passagers, de votre personnel, de vos colis, des visites techniques, de l'embarquement, et bien plus encore. ")
], -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center justify-between" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "text-2xl text-gray-200" }, "Félicitation, votre logiciel est en fin prêt"),
    /*#__PURE__*/_createElementVNode("p", { class: "my-5 text-gray-400" }, [
      /*#__PURE__*/_createTextVNode(" Nous vous proposons de suivre le guide de prise en main de votre nouveau logiciel en cliquant sur le bouton "),
      /*#__PURE__*/_createElementVNode("strong", null, "Démarrer le guide"),
      /*#__PURE__*/_createTextVNode(" ou alors vous pouvez simpler l'ignorer. ")
    ])
  ])
], -1)
const _hoisted_17 = { class: "flex flex-row items-center justify-between" }
const _hoisted_18 = { class: "flex flex-col" }
const _hoisted_19 = {
  key: 0,
  class: "my-5 text-gray-400"
}
const _hoisted_20 = {
  key: 1,
  class: "text-lg text-accent"
}
const _hoisted_21 = {
  key: 2,
  class: "my-5 text-gray-400"
}
const _hoisted_22 = {
  key: 3,
  class: "my-5 text-gray-400"
}
const _hoisted_23 = { class: "flex flex-row items-center justify-between" }
const _hoisted_24 = { class: "flex flex-col w-2/3" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("p", { class: "text-2xl text-gray-200" }, " Pour terminer votre configuration, nous vous invitons à enregistrer les informations essentielles suivantes: ", -1)
const _hoisted_26 = { class: "flex flex-col w-full my-5 space-y-3 text-gray-400" }
const _hoisted_27 = { class: "flex items-start space-x-2" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", { class: "break-normal" }, " Enregistrer au moins un Véhicule de votre flotte", -1)
const _hoisted_29 = { class: "flex items-start space-x-2" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", { class: "break-normal" }, "Enregistrer au moins un Chauffeur responsable des véhicule de votre flotte", -1)
const _hoisted_31 = { class: "flex items-start space-x-2" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("span", { class: "break-normal" }, "Enregistrer au moins un itinéraire", -1)
const _hoisted_33 = { class: "flex items-start space-x-2" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", { class: "break-normal" }, "Enregistrer au moins un Type de Ticket", -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("p", { class: "" }, "Pas d'inquiétude, Nous allons vous guider pas à pas", -1)
const _hoisted_36 = {
  class: /*#__PURE__*/_normalizeClass({ 'flex flex-row items-end justify-start w-full': true, 'justify-start': true })
}
const _hoisted_37 = { class: "flex flex-row items-center justify-between" }
const _hoisted_38 = { class: "flex flex-col" }
const _hoisted_39 = { class: "text-gray-200 text-normal" }
const _hoisted_40 = {
  key: 0,
  class: /*#__PURE__*/_normalizeClass({ 'flex flex-col items-end  w-full': true })
}

import api from "@/api";
	import useAccess from "@/composable/useAccess";
	import useCashierSession from "@/composable/useCashierSession";
	import { dashboardRoutes, stationPageRoutesPolicy } from "@/router/helper";
	import getMenu from "@/router/menu";
	import { storageConfig } from "@/state/api/userState";
	import OnboardService from "@/services/global/OnboardingService";
	import PrerequisitesService, {
		enableNextStepButton,
		recapitulationInfo,
		statusOK,
		wizardClose,
		wizardComplete,
		wizardInit,
	} from "@/services/global/prerequisitesService";
	import { currentStation, isStationSwitching, userInfos } from "@/state/api/userState";
	// storageConfig already imported above
	import {
		currentStationIDSession,
		currentStationUUIDSession,
	} from "@/state/services/sessionState";
	import { useStationsStore } from "@/stores/stations.store";
	import { getParam } from "@/utils";
	import { startCase, toLower, toUpper, replace } from "lodash";
	import { storeToRefs } from "pinia";
	import { defineAsyncComponent, onBeforeMount, onMounted, ref, watch, computed } from "vue";
	import { useRoute, useRouter } from "vue-router";
	import AsyncLoader from "@/components/widgets/AsyncLoader.vue";

	// WizardAssistance ne s'affiche qu'au premier prérequis manquant (rare).
	// On le lazy-load pour ne pas plomber le bundle initial avec un modal
	// qui n'apparaît qu'occasionnellement. Le `v-if="showWizardModal"` garantit
	// que le code n'est téléchargé qu'au moment où le modal doit s'afficher.
	
export default /*#__PURE__*/_defineComponent({
  __name: 'AppHeader',
  setup(__props) {

	const WizardAssistance = defineAsyncComponent({
		loader: () =>
			import(
				/* webpackChunkName: "wizard-assistance" */ "@/components/widgets/modals/WizardAssistance.vue"
			),
		delay: 200,
		timeout: 30000,
		loadingComponent: AsyncLoader,
	});

	const route = useRoute();
	const router = useRouter();
	const store = useStationsStore();
	const { stations } = storeToRefs(store);

	// Session de caisse — affichée comme un badge dans le header pour
	// que le caissier voie en permanence l'état (ouvert/fermé +
	// montant attendu). Cliquer dessus redirige sur « Ma Caisse ».
	const {
		isOpen: hasOpenCashierSession,
		currentSession: cashierSessionData,
		currentBreakdown: cashierBreakdown,
	} = useCashierSession();
	const showCashierBadge = computed(() =>
		useAccess("visibility", ["PassengerCashier", "ParcelCashier", "MainCashier"])
	);

	// Resolve the current menu entry's title (FR or EN) from the active route name.
	const pageTitle = computed(() => {
		const lang = storageConfig.value?.lang || "fr";
		const match = getMenu().find((m: any) => m.route === route.name);
		if (match?.title) return match.title[lang] || match.title.fr || match.title.en || "";
		return startCase(
			toLower(
				String(route.name || "")
					.split("-")
					.pop() || ""
			)
		);
	});
	const isLoading = ref(false);
	const isLoadingSync = ref(false);
	const isLoadingSyncStats = ref(false);
	const isLoadingSyncStatus = ref(false);
	const showSyncStats = ref(true);
	const syncStatus: any = ref(null);
	const syncResult: any = ref(null);
	const syncStats: any = ref(null);
	const showSyncButton = ref(false);
	const syncOperation = ref("");
	const showWizardModal = ref(false);
	const showModal = ref(false);
	const showSyncModal = ref(false);
	const showRecapitulationModal = ref(false);
	// const stations: any = ref([]);
	const disableSwitchTag = ref(false);
	const isOnDashboardPage = ref(false);
	const currentStep: any = ref(null);
	const driver: any = ref(null);
	const modalName = ref("newRequiredGlobalInfoModal");
	const modalNameSync = ref("modalNameSync");
	const modalNameWizardComplete = ref("newWizardModalComplete");
	const modalNameWizard = ref("newWizardModal");
	const modalNameRecapitulation = ref("newRecapitulationModal");

	watch(
		() => route.name,
		async (newValue) => {
			// show welcome msg first only
			isOnDashboardPage.value = false;

			toogleAgencySwitchTag(newValue);

			if (useAccess("visibility", ["Admin", "CoAdmin"])) {
				if (stations.value?.length != 0 || stationPageRoutesPolicy.every((r) => r == newValue)) {
					showModal.value = false;
				} else {
					showModal.value = true;
				}
			}

			// updateUrl(currentStation.value?.key)
		}
	);

	/**
	 * Ce Watcher demarre soit un modal de creation de succursale, soit une configuration de base de la succursale
	 * Pour un modal de creation de succursale, l'utilisateur connecteur doit disoser du role admin ou co-admin
	 * Pour un modal de configuration de base, l'utilisateur doit etre soit admin, co-admin ou second-admin
	 *
	 * Ne peut creer une succursale que si l'user actuel ne dispose pas de succursale avec le role qu'il dispose
	 * Ne peut configurer une succursale que celui dont la succursale courante est valide, ie sa key(currentStation.value?.key) est different -1
	 */
	const unwatch = watch(
		() => stations.value,
		async () => {
			if (useAccess("visibility", ["Admin", "CoAdmin", "SecondAdmin"])) {
				if (dashboardRoutes.every((r) => r == route.name) && stations.value.length >= 2) {
					// lancer la verification des prerequis dde configuration de l'espace courant
					if (currentStation.value?.key != null && currentStation.value?.key != -1) {
						await runPrerequisitesService();
					}
				} else if (dashboardRoutes.every((r) => r == route.name) && stations.value.length === 1) {
					// pas d'agence au sein de l'entreprise si on est du role admin ou co-admin (on dispose de la vue d'ensemble), ou on est second-admin (pas de vue d'ensemble) on a effectivement une agence qui n'est pas la vue d'ensemble
					// Modal invitant à créer une agence seulement les admins et co-admins
					if (useAccess("visibility", ["Admin", "CoAdmin"])) {
						showModal.value = true;
					} else {
						// pour les second-admins
						await runPrerequisitesService();
					}
				} else if (!dashboardRoutes.every((r) => r == route.name) && stations.value.length >= 1) {
					// ici, la vue d'ensemble n'est pas incluse car on ne se trouve pas dans l'espace dashboard et s'il existe une station au moins, lancer la verification des prerequis de configuration de l'espace courant
					await runPrerequisitesService();
				} else if (
					/*route.name == "workspace-agency-overview"*/ stationPageRoutesPolicy.every(
						(r) => r == route.name
					)
				) {
					// Modal invitant à créer une agence
					showModal.value = false;
				} else if (useAccess("visibility", ["Admin", "CoAdmin"])) {
					// Modal invitant à créer une agence uniquement pour les admins et co-admins
					showModal.value = true;
				}
			}

			unwatch();
		}
	);

	watch(
		() => currentStation.value,
		(newVal: any, old: any) => {
			if (currentStation.value?.key) {
				updateUrl(currentStation.value?.key);
				currentStationIDSession.value = currentStation.value?.key;
				currentStationUUIDSession.value = currentStation.value?.uuid;
			}
		}
	);

	watch(
		() => statusOK.value,
		() => {
			// si le status des prerequis est false, declencher le modal
			if (!statusOK.value) showRecapitulationModal.value = true;
			else showRecapitulationModal.value = false;
		}
	);

	watch(
		() => wizardComplete.value,
		() => {
			// si le status des prerequis est false, declencher le modal
			if (wizardComplete.value) closeWizardModal(modalNameWizard.value);
		}
	);

	watch(recapitulationInfo.value, () => {
		setCurrentStep();
	});

	/**
	 * Écrit l'agence courante dans l'URL — via le routeur, PAS via
	 * history.pushState.
	 *
	 * pushState modifie la barre d'adresse sans que vue-router en sache
	 * rien : `route.query.station` restait figé sur l'agence du dernier
	 * chargement. Or `getCurrentSelectedStation()` lit précisément
	 * `route.query.station` et le repasse au SwitchTag via `:selected`,
	 * dont le watchEffect re-dispatche un événement `input`. Choisir une
	 * autre agence déclenchait donc immédiatement un retour à la
	 * précédente : le sélecteur revenait en arrière et la page restait
	 * bloquée sur les données de l'agence initiale.
	 *
	 * router.replace tient `route.query` à jour, ce qui casse la boucle.
	 * On fusionne la query existante pour ne pas effacer les paramètres
	 * des pages (ex. `?tab=` sur les expéditions), et on ne navigue que
	 * si la valeur change réellement (sinon vue-router rejette une
	 * navigation redondante).
	 */
	const updateUrl = (stationID = 0) => {
		const allowed =
			useAccess("visibility", ["Admin", "CoAdmin"]) &&
			stationID !== 0 &&
			stationPageRoutesPolicy.every((r) => r !== route.name);
		if (!allowed) return;

		const next = String(stationID);
		if (String(route.query.station ?? "") === next) return;

		router
			.replace({ query: { ...route.query, station: next } })
			.catch(() => {
				/* navigation redondante ou annulée : sans effet ici */
			});
	};

	// routeName == "workspace-agency-overview"
	function toogleAgencySwitchTag(routeName: any) {
		if (routeName && stationPageRoutesPolicy.every((r) => r == routeName)) {
			disableSwitchTag.value = true;
		} else {
			disableSwitchTag.value = false;
		}
	}

	const modalState = (e: any) => {
		if (e === modalName.value) showModal.value = false;
	};

	const closeModalRecap = (e: any) => {
		if (e === modalNameRecapitulation.value) showRecapitulationModal.value = false;
	};

	const closeWizardModal = (e: any) => {
		if (e === modalNameWizard.value) showWizardModal.value = false;
	};

	const closeSyncModal = (e: any) => {
		if (e === modalNameSync.value) showSyncModal.value = false;
	};

	const closeWizardCompleteModal = (e: any) => {
		if (e === modalNameWizardComplete.value) wizardClose.value = true;
	};

	const runWizard = async (e: any) => {
		closeModalRecap(modalNameRecapitulation.value);
		showWizardModal.value = true;
		wizardInit.value = true;

		// redirect to dashboard
		await router.push({ name: currentStep.value?.routeName, query: currentStep.value?.query });
		e.stopPropagation();
		OnboardService.runNewButtonOperation(currentStep.value);
	};

	const runPrerequisitesService = async () => {
		await PrerequisitesService.run(currentStation.value);

		// si le status des prerequis est false, declencher le modal
		if (!statusOK.value) showRecapitulationModal.value = true;
	};

	const execOnboardIntroduction = async (e: any) => {
		e.stopPropagation();
		closeWizardCompleteModal(modalNameWizardComplete.value);

		// redirect to dasboard
		await router.push({ name: "workspace-dashboard" });

		// then, running OnboardService
		OnboardService.runIntroduction();
	};

	const setCurrentStep = () => {
		// init the current step wizard Assistance
		Object.keys(recapitulationInfo.value).every((key) => {
			if (recapitulationInfo.value[key].status == 0) {
				currentStep.value = recapitulationInfo.value[key];
				return false;
			}
			return true;
		});
	};

	const goTo = async (e: any) => {
		enableNextStepButton.value = false;
		await router.push({ name: currentStep.value?.routeName, query: currentStep.value?.query });
		e.stopPropagation();
		OnboardService.runNewButtonOperation(currentStep.value);
	};

	let _stationSwitchTimer: any = null;
	const onStationSwitched = (e: any) => {
		// Détecte un vrai changement (clé différente) avant d'allumer
		// l'overlay — éviter le flash lors de l'init du SwitchTag qui
		// peut re-dispatcher la même sélection.
		const newKey = e?.key ?? null;
		const oldKey = currentStation.value?.key ?? null;
		currentStation.value = e;

		if (newKey != null && newKey !== oldKey) {
			isStationSwitching.value = true;
			if (_stationSwitchTimer) clearTimeout(_stationSwitchTimer);
			_stationSwitchTimer = setTimeout(() => {
				isStationSwitching.value = false;
				_stationSwitchTimer = null;
			}, 700);
		}
	};

	const getCurrentSelectedStation = () => {
		if (!disableSwitchTag.value) {
			if (route.query.station && useAccess("stationBelongTo", [route.query.station as string])) {
				return route.query.station;
			}
			return currentStation.value?.key ?? 0;
		}
		return 0;
	};

	const launchSyncProcess = () => {
		showSyncModal.value = true;
	};

	const startSynchronisation = async () => {
		isLoadingSync.value = true;
		await api()
			.sync.syncUp()
			.then(async (res: any) => {
				await searchingForDataToSynchronize();
				syncResult.value = res.data;
				showSyncStats.value = false;
				syncOperation.value = "Terminée avec succès.";
			})
			.catch((err: any) => {
				console.log(err);
				showSyncStats.value = false;
				syncOperation.value = "Échouée. Veuillez réessayer plus tard.";
			});
		isLoadingSync.value = false;
	};

	const searchingForDataToSynchronize = async () => {
		isLoadingSyncStats.value = true;
		await api()
			.sync.verifDataToSync()
			.then((res: any) => {
				syncStats.value = res.data;
				showSyncStats.value = true;
			})
			.catch((err: any) => {
				console.log(err);
			});
		isLoadingSyncStats.value = false;
	};

	const getSyncStatus = async () => {
		isLoadingSyncStatus.value = true;
		await api()
			.sync.getSyncStatus()
			.then((res: any) => {
				syncStatus.value = res.data;
				if (res.data.value == "false") {
					showSyncButton.value = false;
				} else if (res.data.value == "true") {
					showSyncButton.value = true;
				}
			})
			.catch((err: any) => {
				console.log(err);
			});
		isLoadingSyncStatus.value = false;
	};

	/**
	 * App Lifecycle
	 */
	onBeforeMount(async () => {
		toogleAgencySwitchTag(route.name);

		if (useAccess("visibility", ["Admin", "CoAdmin"]) && route.name == "workspace-dashboard") {
			isOnDashboardPage.value = true;
		}

		// Wizard Assistance
		setCurrentStep();

		await getSyncStatus();
	});

	onMounted(() => {
		// OnboardService.runIntroduction();
		if (route.query.station) updateUrl((route.query.station as unknown) as number);
		else if (currentStation.value?.key) updateUrl(currentStation.value?.key);
	});

return (_ctx: any,_cache: any) => {
  const _component_SearchBar = _resolveComponent("SearchBar")!
  const _component_SwitchTag = _resolveComponent("SwitchTag")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_SynchronizationBadge = _resolveComponent("SynchronizationBadge")!
  const _component_NotificationBadge = _resolveComponent("NotificationBadge")!
  const _component_Image = _resolveComponent("Image")!
  const _component_ButtonTag = _resolveComponent("ButtonTag")!
  const _component_ModalPage = _resolveComponent("ModalPage")!
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(toUpper)(pageTitle.value)), 1),
          _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(replace)(_unref(startCase)(_unref(toLower)(_unref(route).name)), / /g, " > ")), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_SearchBar),
          (
						_unref(userInfos)?.stations?.length >= 1 &&
						_unref(useAccess)('visibility', ['Admin', 'CoAdmin']) &&
						!disableSwitchTag.value
					)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _hoisted_8,
                _createVNode(_component_SwitchTag, {
                  placeholder: "Agence de...",
                  css: "!bg-[#19202A] border-none focus-within:ring-[#19202A] py-1.5",
                  bgDropDown: "bg-[#19202A]",
                  data: JSON.stringify(_unref(stations)),
                  selected: getCurrentSelectedStation(),
                  onModel: onStationSwitched
                }, null, 8, ["data", "selected"])
              ]))
            : _createCommentVNode("", true),
          (showCashierBadge.value)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 1,
                to: { name: 'workspace-my-cashier-session' },
                class: _normalizeClass([
						'flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-medium border transition-colors',
						_unref(hasOpenCashierSession)
							? 'bg-emerald-500/15 border-emerald-500/40 text-emerald-300 hover:bg-emerald-500/25'
							: 'bg-amber-500/10 border-amber-500/30 text-amber-300 hover:bg-amber-500/20',
					]),
                title: 
						_unref(hasOpenCashierSession)
							? 'Caisse ouverte — cliquer pour clôturer'
							: 'Aucune caisse ouverte — cliquer pour ouvrir'
					
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", {
                    class: _normalizeClass(["inline-block w-2 h-2 rounded-full", _unref(hasOpenCashierSession) ? 'bg-emerald-400' : 'bg-amber-400'])
                  }, null, 2),
                  (_unref(hasOpenCashierSession))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_9, " Caisse ouverte "))
                    : (_openBlock(), _createElementBlock("span", _hoisted_10, "Pas de caisse"))
                ]),
                _: 1
              }, 8, ["class", "title"]))
            : _createCommentVNode("", true),
          (showSyncButton.value)
            ? (_openBlock(), _createBlock(_component_SynchronizationBadge, {
                key: 2,
                onClick: launchSyncProcess
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_NotificationBadge)
        ])
      ])
    ]),
    (showModal.value)
      ? (_openBlock(), _createBlock(_component_ModalPage, {
          key: 0,
          title: isOnDashboardPage.value ? 'Bienvenue à bord !' : 'Information Requise',
          name: modalName.value,
          styleContent: "w-full",
          styleFooter: "w-full",
          styleModal: '!w-3/6',
          onClose: _cache[1] || (_cache[1] = (e) => modalState(e)),
          mounted: "(e:any) => getData()"
        }, {
          content: _withCtx(() => [
            (isOnDashboardPage.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _hoisted_12,
                  _createVNode(_component_Image, {
                    src: "/media/images/illustrations/welcome-animate-2.svg",
                    css: "block w-[300px] h-[300px]"
                  })
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15))
          ]),
          footer: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass({
					'flex flex-row items-end justify-start w-full': true,
					[isOnDashboardPage.value ? 'justify-start' : 'justify-end']: true,
				})
            }, [
              _createVNode(_component_ButtonTag, {
                label: "Aller à la page des succursales",
                activeIcon: true,
                icon: "/media/icons/add-icon.svg",
                loader: isLoading.value,
                "text-loading": 'Création en cours...',
                css: "bg-[#219152] border-secondary text-white px-6 py-2 hover:bg-[#167841] w-full active:bg-[#219152]  focus:outline-none ",
                onClick: _cache[0] || (_cache[0] = 
						async (e) => {
							await _unref(router).push({ name: 'workspace-agency-overview' });
							//e.stopPropagation()
							//OnboardService.runNewButtonStation(currentStep);
						}
					)
              }, null, 8, ["loader"])
            ], 2)
          ]),
          _: 1
        }, 8, ["title", "name"]))
      : _createCommentVNode("", true),
    (_unref(wizardInit) && _unref(wizardComplete) && !_unref(wizardClose))
      ? (_openBlock(), _createBlock(_component_ModalPage, {
          key: 1,
          title: 'Configuration Terminée',
          name: modalNameWizardComplete.value,
          styleContent: "w-full",
          styleFooter: "w-full",
          styleModal: '!w-2/6',
          onClose: _cache[4] || (_cache[4] = (e) => closeWizardCompleteModal(e)),
          mounted: "(e:any) => getData()"
        }, {
          content: _withCtx(() => [
            _hoisted_16
          ]),
          footer: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass({
					'flex flex-row items-end justify-start w-full space-x-4': true,
					[isOnDashboardPage.value ? 'justify-start' : 'justify-end']: true,
				})
            }, [
              _createVNode(_component_ButtonTag, {
                label: "Ignorer",
                activeIcon: false,
                icon: "/media/icons/add-icon.svg",
                css: "bg-gray-500 border-secondary text-white px-6 py-2 hover:bg-gray-600 w-full active:bg-gray-500  focus:outline-none ",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (closeWizardCompleteModal(modalNameWizardComplete.value)))
              }),
              _createVNode(_component_ButtonTag, {
                label: "Démarrer le guide",
                activeIcon: false,
                icon: "/media/icons/add-icon.svg",
                loader: isLoading.value,
                "text-loading": 'Création en cours...',
                css: "bg-[#219152] border-secondary text-white px-6 py-2 hover:bg-[#167841] w-full active:bg-[#219152]  focus:outline-none ",
                onClick: _cache[3] || (_cache[3] = (e) => execOnboardIntroduction(e))
              }, null, 8, ["loader"])
            ], 2)
          ]),
          _: 1
        }, 8, ["name"]))
      : _createCommentVNode("", true),
    (showSyncModal.value)
      ? (_openBlock(), _createBlock(_component_ModalPage, {
          key: 2,
          title: 'Terminal de Synchronisation',
          name: modalNameSync.value,
          styleContent: "w-full",
          styleFooter: "w-full",
          styleModal: '!w-2/6',
          onClose: _cache[7] || (_cache[7] = (e) => closeSyncModal(e)),
          onMounted: _cache[8] || (_cache[8] = (e) => searchingForDataToSynchronize())
        }, {
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                (isLoadingSyncStats.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_19, "Recherche en cours..."))
                  : (!isLoadingSyncStats.value && !isLoadingSync.value && showSyncStats.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_20, " Donnees a synchroniser : " + _toDisplayString(syncStats.value?.total_data_to_sync ?? ""), 1))
                    : _createCommentVNode("", true),
                (isLoadingSync.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_21, "En cours de Synchronisation..."))
                  : (!isLoadingSync.value && !showSyncStats.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_22, " Synchronisation " + _toDisplayString(syncOperation.value), 1))
                    : _createCommentVNode("", true)
              ])
            ])
          ]),
          footer: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass({
					'flex flex-row items-end justify-start w-full space-x-4 mt-4': true,
					[isOnDashboardPage.value ? 'justify-start' : 'justify-end']: true,
				})
            }, [
              _createVNode(_component_ButtonTag, {
                label: showSyncStats.value ? 'Annuler' : 'Fermer',
                activeIcon: false,
                icon: "/media/icons/add-icon.svg",
                css: "bg-gray-500 border-secondary text-white px-6 py-2 hover:bg-gray-600 w-full active:bg-gray-500  focus:outline-none ",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (closeSyncModal(modalNameSync.value)))
              }, null, 8, ["label"]),
              (syncStats.value?.total_data_to_sync !== 0)
                ? (_openBlock(), _createBlock(_component_ButtonTag, {
                    key: 0,
                    label: "Démarrer la Synchronisation",
                    activeIcon: false,
                    icon: "/media/icons/add-icon.svg",
                    loader: isLoadingSync.value,
                    "text-loading": 'Processing...',
                    css: "bg-[#219152] border-secondary text-white px-6 py-2 hover:bg-[#167841] w-full active:bg-[#219152]  focus:outline-none ",
                    onClick: _cache[6] || (_cache[6] = (e) => startSynchronisation())
                  }, null, 8, ["loader"]))
                : _createCommentVNode("", true)
            ], 2)
          ]),
          _: 1
        }, 8, ["name"]))
      : _createCommentVNode("", true),
    (showRecapitulationModal.value)
      ? (_openBlock(), _createBlock(_component_ModalPage, {
          key: 3,
          title: 'Plus que quelques étapes pour commencer',
          name: modalNameRecapitulation.value,
          styleContent: "w-full",
          styleFooter: "w-full",
          styleModal: '!w-3/6',
          onClose: _cache[10] || (_cache[10] = (e) => closeModalRecap(e)),
          mounted: "(e:any) => getData()"
        }, {
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _hoisted_25,
                _createElementVNode("ul", _hoisted_26, [
                  _createElementVNode("li", _hoisted_27, [
                    _createVNode(_component_Icon, {
                      css: "min-w-[1.25rem] w-5 h-5 mt-0.5",
                      src: 
									_unref(recapitulationInfo).vehicle.status == 0
										? '/media/icons/icon-uncheck.svg'
										: '/media/icons/icon-check.svg'
								
                    }, null, 8, ["src"]),
                    _hoisted_28
                  ]),
                  _createElementVNode("li", _hoisted_29, [
                    _createVNode(_component_Icon, {
                      css: "min-w-[1.25rem]  w-5 h-5 mt-0.5",
                      src: 
									_unref(recapitulationInfo).driver.status == 0
										? '/media/icons/icon-uncheck.svg'
										: '/media/icons/icon-check.svg'
								
                    }, null, 8, ["src"]),
                    _hoisted_30
                  ]),
                  _createElementVNode("li", _hoisted_31, [
                    _createVNode(_component_Icon, {
                      css: "min-w-[1.25rem] w-5 h-5 mt-0.5",
                      src: 
									_unref(recapitulationInfo).travelRoute.status == 0
										? '/media/icons/icon-uncheck.svg'
										: '/media/icons/icon-check.svg'
								
                    }, null, 8, ["src"]),
                    _hoisted_32
                  ]),
                  _createElementVNode("li", _hoisted_33, [
                    _createVNode(_component_Icon, {
                      css: "min-w-[1.25rem] w-5 h-5 mt-0.5",
                      src: 
									_unref(recapitulationInfo).ticketType.status == 0
										? '/media/icons/icon-uncheck.svg'
										: '/media/icons/icon-check.svg'
								
                    }, null, 8, ["src"]),
                    _hoisted_34
                  ])
                ]),
                _hoisted_35
              ]),
              _createVNode(_component_Image, {
                src: "/media/images/illustrations/process-animate-1.svg",
                css: "block w-[300px] h-[300px] --rotate-45"
              })
            ])
          ]),
          footer: _withCtx(() => [
            _createElementVNode("div", _hoisted_36, [
              _createVNode(_component_ButtonTag, {
                label: `Etape ${currentStep.value?.step}/${
						Object.keys(_unref(recapitulationInfo)).length
					} : Enregistrer un ${currentStep.value?.label}`,
                activeIcon: true,
                icon: "/media/icons/arrow-right-icon.svg",
                iconStyle: "w-4 h-4",
                loader: isLoading.value,
                "text-loading": 'Création en cours...',
                css: "bg-[#219152] border-secondary text-white px-6 py-2 hover:bg-[#167841] w-full active:bg-[#219152]  focus:outline-none ",
                onClick: _cache[9] || (_cache[9] = (e) => runWizard(e))
              }, null, 8, ["label", "loader"])
            ])
          ]),
          _: 1
        }, 8, ["name"]))
      : _createCommentVNode("", true),
    (showWizardModal.value)
      ? (_openBlock(), _createBlock(_unref(WizardAssistance), {
          key: 4,
          title: 'Assistance de configuration',
          name: modalNameWizard.value,
          styleContent: "w-full",
          styleFooter: "w-full",
          styleModal: '',
          onClose: _cache[12] || (_cache[12] = (e) => closeModalRecap(e)),
          mounted: "(e:any) => getData()"
        }, {
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("p", _hoisted_39, _toDisplayString(`Etape ${currentStep.value.step}/${Object.keys(_unref(recapitulationInfo)).length} en cours :`), 1)
              ])
            ])
          ]),
          footer: _withCtx(() => [
            (_unref(enableNextStepButton))
              ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                  _createVNode(_component_ButtonTag, {
                    label: `Enregistrer un ${currentStep.value?.label}`,
                    activeIcon: true,
                    iconStyle: "w-4 h-4",
                    icon: "/media/icons/arrow-right-icon.svg",
                    css: "bg-[#219152] border-secondary text-white px-6 py-2 hover:bg-[#167841] w-full active:bg-[#219152]  focus:outline-none ",
                    onClick: _cache[11] || (_cache[11] = async (e) => await goTo(e))
                  }, null, 8, ["label"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["name"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})